import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ExplanationItem from './ExplanationItem';
import MatchingListItem from './MatchingListItem';
import preventLink from './prevenLink';
import useWindowHeight from 'components/Dashboard/utilities/useWindowHeight';
import { Portal } from 'react-portal';

const MoreTagsContainer = ({
  terms,
  matchingKeywordLists,
  calendarTags,
  showMoreTags,
  setShowMoreTags,
  positionStyles,
  moreItems,
  explanationProps,
}) => {
  return (
    <>
      {showMoreTags && (
        <div className='more-tags-container' style={positionStyles}>
          <p
            className='less-tags px-3 py-2 mb-0'
            onClick={(e) => {
              preventLink(e);
              setShowMoreTags(false);
            }}
          >
            less
            <span className='icon-arrow-down light-40-text d-inline-block-centered mt-0 specific-left-margin-4' />
          </p>
          <div className='px-3 pb-2'>
            {terms.slice(terms?.length - moreItems)?.map((item, index) => {
              if (matchingKeywordLists) {
                return <MatchingListItem item={item} key={`keywordlist-${index}`} calendarTags={calendarTags} />;
              } else {
                return <ExplanationItem {...explanationProps} name={item} key={`explanation-${index}`} />;
              }
            })}
          </div>
        </div>
      )}
    </>
  );
};

const RenderingTags = (props) => {
  const { terms, matchingKeywordLists, calendarTags, fixedPosition, scrollBarRef } = props;
  const [showMoreTags, setShowMoreTags] = useState(false);
  const { windowWidth } = useWindowHeight();

  const tagsContainerElement = useRef(null);
  const tagsElementsContainer = useRef(null);

  const moreElement = useRef(null);
  const [moreItems, setMoreItems] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [positionStyles, setPositionStyles] = useState({});

  useEffect(() => {
    const items = tagsContainerElement?.current
      ? [...tagsContainerElement?.current?.querySelectorAll(`.explanation-container`)]?.filter(
          (item) => item?.offsetTop > 0
        )
      : [];
    setMoreItems(items?.length);
  }, [windowWidth, tagsContainerElement.current]);

  useEffect(() => {
    if (tagsElementsContainer?.current) {
      const children = Array.from(tagsElementsContainer?.current?.children);
      if (children.length > 0) {
        const firstChildTop = children[0].offsetTop;
        const firstRowChildren = children.filter((child) => child.offsetTop === firstChildTop);
        const lastInFirstRow = firstRowChildren[firstRowChildren.length - 1];
        if (!!lastInFirstRow) {
          const { width } = lastInFirstRow?.getBoundingClientRect() ?? {};
          setContainerWidth(width + lastInFirstRow?.offsetLeft);
        }
      }
    }
  }, [windowWidth, terms]);

  const updatePositionStyles = () => {
    if (fixedPosition && moreElement?.current) {
      const rect = moreElement.current.getBoundingClientRect();
      setPositionStyles({
        position: 'fixed',
        top: rect.top - 4,
        left: rect.left,
      });
    }
  };

  useLayoutEffect(() => {
    updatePositionStyles();
    window.addEventListener('resize', updatePositionStyles);

    const scrollElement = scrollBarRef?.current?.view;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', updatePositionStyles);
    }

    return () => {
      window.removeEventListener('resize', updatePositionStyles);
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', updatePositionStyles);
      }
    };
  }, [scrollBarRef, fixedPosition, moreElement, showMoreTags]);

  return (
    <div className='flex-centered rendering-items-container position-relative' ref={tagsContainerElement}>
      <div
        className='d-flex align-items-start flex-wrap overflow-hidden position-relative'
        style={{ maxHeight: '34px' }}
        ref={tagsElementsContainer}
      >
        {terms.map((item, index) => {
          if (matchingKeywordLists) {
            return <MatchingListItem item={item} key={`keywordlist-${index}`} calendarTags={calendarTags} />;
          } else {
            return <ExplanationItem {...props} name={item} key={`explanation-${index}`} />;
          }
        })}
      </div>

      <div
        className='more-tags-text position-absolute'
        ref={moreElement}
        style={{ visibility: moreItems > 0 ? 'visible' : 'hidden', left: `${containerWidth}px` }}
      >
        <div className='position-relative'>
          <span
            className='more-text nowrap-item'
            onClick={(e) => {
              preventLink(e);
              setShowMoreTags(true);
            }}
          >
            {moreItems} more <span className='icon-arrow-down light-40-text' />
          </span>
          {fixedPosition ? (
            <Portal node={document && document.querySelector('body')}>
              <div className='explanations-fixed-position'>
                <MoreTagsContainer
                  terms={terms}
                  matchingKeywordLists={matchingKeywordLists}
                  calendarTags={calendarTags}
                  showMoreTags={showMoreTags}
                  setShowMoreTags={setShowMoreTags}
                  positionStyles={positionStyles}
                  moreItems={moreItems}
                  explanationProps={props}
                />
              </div>
            </Portal>
          ) : (
            <MoreTagsContainer
              terms={terms}
              matchingKeywordLists={matchingKeywordLists}
              calendarTags={calendarTags}
              showMoreTags={showMoreTags}
              setShowMoreTags={setShowMoreTags}
              positionStyles={positionStyles}
              moreItems={moreItems}
              explanationProps={props}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RenderingTags;
